import React from 'react';
import { inject, observer } from 'mobx-react';
import { Drawer, DrawerContent } from '@rmwc/drawer';
import {
  List,
  ListDivider,
  ListGroup,
  ListGroupSubheader,
  SimpleListItem,
} from '@rmwc/list';
import Button from '@mui/material/Button';

@inject('headerState')
@observer
class MobileNav extends React.PureComponent {
  handleDrawerClose = () => {
    this.props.headerState.closeDrawer();
  };

  render() {
    const { drawerOpen, mvcHomePath, memberSignedIn } = this.props.headerState;

    return (
      <Drawer modal open={drawerOpen} onClose={this.handleDrawerClose}>
        <DrawerContent>
          <List>
            <SimpleListItem tag="a" href={mvcHomePath} text="Home" />

            <ListDivider tag="hr" />

            <ListGroup>
              <ListGroupSubheader>About Us</ListGroupSubheader>
              <SimpleListItem
                tag="a"
                href="/mvc-awards/mission-statement"
                text="Mission Statement"
              />
              <SimpleListItem
                tag="a"
                href="/mvc-awards/frequently-asked-questions"
                text="FAQs"
              />
              <SimpleListItem
                tag="a"
                href="/mvc-awards/award-rules"
                text="Award Rules"
              />
            </ListGroup>

            <ListDivider tag="hr" />

            <SimpleListItem
              tag="a"
              href="/mvc-awards/categories"
              text="Categories"
            />
            <SimpleListItem
              tag="a"
              href="/mvc-awards/contact-us"
              text="Contact"
            />

            {memberSignedIn || (
              <>
                <Button
                  variant="contained"
                  tag="a"
                  className="nav-menu-button"
                  href="/mvc-awards/sign_in"
                >
                  Log In
                </Button>

                <Button
                  variant="contained"
                  tag="a"
                  className="nav-menu-button sign-up-button"
                  href="/mvc-awards/sign_up"
                >
                  Sign Up
                </Button>
              </>
            )}
          </List>
        </DrawerContent>
      </Drawer>
    );
  }
}

export default MobileNav;
